module.exports = __webpack_public_path__ + "static/img/SG.7695f8b3.jpg";